module.exports = __webpack_public_path__ + "img/Groove Phi Groove Reunion 2000.03609613.jpg";